import { DashboardSettings } from 'components/DashboardSettings/DashboardSettings';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useDashboard } from '../Dashboard.context';
import styles from './DashboardHeader.module.css';
import { ExportCSVButton } from './ExportCSVButton/ExportCSVButton';
import { QuickFilters } from './QuickFilters/QuickFilters';
import { SearchBar } from './SearchBar/SearchBar';

export const DashboardHeader = () => {
  const {
    state: { error },
  } = useDashboard();

  const { isContextError } = useIntroducerData();

  if (error || isContextError) {
    return null;
  }

  return (
    <header className={styles.header}>
      <div className={styles.leftSection}>
        <QuickFilters />
        <SearchBar />
      </div>

      <div className={styles.rightSection} id="dashboard-tools">
        <ExportCSVButton />
        <DashboardSettings />
      </div>
    </header>
  );
};
